import { useQuery } from '@tanstack/react-query';
import {
  juniperEmailReportApi,
  type JuniperEmailReportParams,
} from '../api/juniperEmailReportApi';

export const JUNIPER_EMAIL_QUERY_KEYS = {
  filterOptions: (params: JuniperEmailReportParams) =>
    ['juniper-email', 'filter-options', params] as const,
  overview: (params: JuniperEmailReportParams) =>
    ['juniper-email', 'overview', params] as const,
  issues: (params: JuniperEmailReportParams) => ['juniper-email', 'issues', params] as const,
  history: (params: JuniperEmailReportParams) => ['juniper-email', 'history', params] as const,
  detail: (attemptId: string, params: JuniperEmailReportParams) =>
    ['juniper-email', 'detail', attemptId, params] as const,
};

export function useJuniperEmailFilterOptions(params: JuniperEmailReportParams) {
  return useQuery({
    queryKey: JUNIPER_EMAIL_QUERY_KEYS.filterOptions(params),
    queryFn: () => juniperEmailReportApi.getFilterOptions(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
  });
}

export function useJuniperEmailOverview(
  params: JuniperEmailReportParams,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: JUNIPER_EMAIL_QUERY_KEYS.overview(params),
    queryFn: () => juniperEmailReportApi.getOverview(params),
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  });
}

export function useJuniperEmailIssues(
  params: JuniperEmailReportParams,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: JUNIPER_EMAIL_QUERY_KEYS.issues(params),
    queryFn: () => juniperEmailReportApi.getIssues(params),
    enabled: options?.enabled ?? true,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  });
}

export function useJuniperEmailHistory(
  params: JuniperEmailReportParams,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: JUNIPER_EMAIL_QUERY_KEYS.history(params),
    queryFn: () => juniperEmailReportApi.getHistory(params),
    enabled: options?.enabled ?? true,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 2,
  });
}
